import { Action, createReducer, on } from '@ngrx/store';
import { Me, MeData } from 'src/app/model/Me';
import * as MeActions from './me.actions';
import * as AuthActions from '../../../auth/store/auth.actions';
import { UserInfo } from 'src/app/model/UserInfo';

export interface State {
  me: MeData | null;
  error: boolean;
  errorMessage: any;
  loading: boolean;
  isHm: boolean | null;
  isHm_doc: boolean | null;
  userInfo: UserInfo | null;
}

const initialState: State = {
  me: null,
  error: false,
  errorMessage: null,
  loading: false,
  isHm: null,
  isHm_doc: null,
  userInfo: null,
};

const _meReducer = createReducer(
  initialState,

  on(MeActions.fetchMe, (state) => ({
    ...state,
    loading: true,
  })),

  on(MeActions.setMe, (state, action) => ({
    ...state,
    me: action.me,
    loading: false,
    isHm: action.me.firstName.match(/HM|Pio|Iovinella/) ? true : false,
    isHm_doc: action.me.firstName.match(/HM_DOC/) ? true : false,
  })),

  on(MeActions.updateMe, (state, action) => ({
    ...state,
    loading: true,
  })),

  on(AuthActions.logout, (state) => ({
    ...state,
    me: null,
    loading: false,
  })),

  on(MeActions.fetchUserInfo, (state) => ({
    ...state,
    loading: true,
  })),

  on(MeActions.fetchUserInfoSuccess, (state, action) => ({
    ...state,
    userInfo: action.userInfo,
    loading: false,
  })),

  on(MeActions.fetchUserInfoFail, (state, action) => ({
    ...state,
    error: true,
    errorMessage: action.error,
    loading: false,
  }))
);

export function meReducer(state: State | undefined, action: Action) {
  return _meReducer(state, action);
}
